import Immutable, { fromJS, Map, List, OrderedSet } from "immutable";

/*
  Static store for static assets
*/

export const initialState = Immutable.fromJS({
  images: {},
  authenticity_token: "",
  countries: [],
});

export default (state = initialState, action) => state;
